import * as R from 'ramda';
import * as Promise from 'bluebird';
import { of, from } from 'rxjs';
import { mergeMap, withLatestFrom, map, catchError } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { dispatch } from 'react-redux';
import { sidebarMenuItemSelected, sidebarMenuItemPrint, sidebarMenuItemPrinted, types } from './sideBar.redux';
import { spectreappCurrentPage } from 'components/spectreApp/spectreApp.redux';
import { isDesktop } from 'components/fileSystem';
import specSheetImages from 'components/specSheetImages';
import { printTemplate } from 'components/printTemplate';
import { datasources } from '../db/datasources';

const sideBarEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.sidebarMenuItemSelected),
    withLatestFrom(state$),
    mergeMap(([{ payload: { menuItemSelected } }, state]) => {
      let pageAction;
      switch (menuItemSelected) {
        case '1':
          pageAction = spectreappCurrentPage({ currentPage: 'bowlers' });
          break;
        case '2':
          pageAction = spectreappCurrentPage({ currentPage: 'specsheet' });
          break;
        case '3':
          pageAction = spectreappCurrentPage({ currentPage: 'arsenal' });
          break;
        case '4':
          pageAction = sidebarMenuItemPrint();
          break;
        case '5':
          pageAction = spectreappCurrentPage({ currentPage: 'settings' });
          break;
        case '6':
          if (state.spectreApp.deviceInfo) {
            pageAction = spectreappCurrentPage({ currentPage: 'deviceInfo' });
          } else {
            pageAction = spectreappCurrentPage({ currentPage: 'loginForm' });
          }
          break;
      }
      return of(pageAction);
    })
  );

const siderbarPrintEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.sidebarMenuItemPrint),
    withLatestFrom(state$),
    mergeMap(([_, state]) => {
      return from(
        new Promise((success, reject) => {
          const lastCustomer = state.spectreApp.lastCustomerInfo.lastCustomer;
          const lastSpecSheet = state.spectreApp.lastCustomerInfo[lastCustomer].lastSpecSheet;
          const { customerDS, specSheetDS, thumbCutDS, ballDrilledDS } = datasources;
          const language = window.localStorage.getItem('spectre_language');
          const imageDirectory = state.spectreApp.imageDirectory;
          Promise.all([
            customerDS.get(lastCustomer),
            specSheetDS.get(lastSpecSheet),
            thumbCutDS.read({ specsheetId: lastSpecSheet }),
            ballDrilledDS.read({ customerId: lastCustomer }),
          ]).then(([currentCustomer, specSheet, thumb_info, arsenal_info]) => {
            try {
              const specsheetImg = specSheetImages[language];

              const printData = {
                specsheetImg,
                specSheet,
                currentCustomer,
                currentArsenal: arsenal_info[0],
                arsenalDS: arsenal_info,
                currentThumbCuts: thumb_info,
                imageDirectory,
              };

              if (!isDesktop()) {
                const printout = printTemplate(R.assoc('contentWithHtml', true, printData));
                cordova.plugins.printer.print(
                  printout,
                  {
                    duplex: 'long',
                    name: printData.currentCustomer.firstname + ' ' + printData.currentCustomer.lastname,
                  },
                  function(res) {
                    console.log(res ? 'Done' : 'Canceled');
                  }
                );
              } else {
                const printout = printTemplate(R.assoc('contentWithHtml', false, printData));
                const ipcRenderer = window.require('electron').ipcRenderer;
                ipcRenderer.send('printHtml', printout);
              }
              success();
            } catch (e) {
              reject(e);
            }
          });
        })
      ).pipe(
        map(() => {
          return sidebarMenuItemPrinted();
        }),
        catchError(error => {
          console.warn(error);
          return sidebarMenuItemPrinted();
        })
      );
    })
  );

export default combineEpics(sideBarEpic, siderbarPrintEpic);
